export default __webpack_public_path__ + "static/media/tpk-2024-tuto-bag.abf1dc89.gif";